export default "__VITE_ASSET__JDaBAe2J__"